//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import { useState, useEffect, useCallback } from "react";
import { Col, Row, Space, Avatar, Button, Typography, message } from "antd";

import Coins from "../../../../../assets/images/AccountsPage/CoinsStack.svg";
import RewardPoints from "../../../../../assets/images/AccountsPage/RewardPoints.svg";

//? Modules -------------------------------------------------------------------->
import "../DashboardModule/DashboardModule.css";
import AccountStatus from "@/functions/Cookies/Cookies";
import OrderCard from "../OrdersListingModule/OrderCard/OrderCard";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
import { useDispatch } from "react-redux";
import { changeActiveMenuReducer } from "@/redux/Slices/accountSlice";
import { ReloadOutlined } from "@ant-design/icons";
import AccountApi from "@/Apis/AccountApi";
import axios from 'axios';


//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function DashboardModule({ userAgent }) {
  const { comverse_customer_token } = AccountStatus();
  const [randomState, setRandomState] = useState(0)
  const dispatch = useDispatch();

  const [DashboardDetails, setDashboardDetails] = useState({});

  // const fetchDashboardDetails = useCallback(async () => {
  //   try {
  //     const headers = {
  //       "Content-Type": "application/json",
  //     };
  //     if (comverse_customer_token) {
  //       headers.Authorization = comverse_customer_token;
  //     }

  //     const payload = {
  //       method: "GET",
  //       headers: headers,
  //     };

  //     const res = await fetch(
  //       `${process.env.NEXT_PUBLIC_BACKEND}/storefront/customer_dashboard?timestamp=${new Date().getTime()}`,
  //       payload
  //     );

  //     const data = await res.json();

  //     if (!res.ok) {
  //       if (data?.detail === "Invalid auth token") {
  //         customerLogout();
  //         dispatch(logoutReducer());
  //         router.push("/login");
  //       }
  //       // Logout here
  //       throw new Error("API Failed!");
  //     }

  //     setDashboardDetails(data);
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //     return null;
  //   }
  // }, [comverse_customer_token]);

  async function fetchDashboardDetails() {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const url = `${process.env.NEXT_PUBLIC_BACKEND}/storefront/customer_dashboard`;
      const params = {
        timestamp: new Date().getTime(),
      };

      const res = await axios.get(url, {
        headers: headers,
        params: params,
      });

      const data = res.data;

      setDashboardDetails(data);
      return data;
    } catch (error) {
      if (error.response) {
        const res = error.response;
        const data = res.data;

        if (data?.detail === "Invalid auth token") {
          message.error("Invalid auth token");
          customerLogout();
          dispatch(logoutReducer());
          router.push("/login");
        }
        throw new Error("API Failed!");
      } else {
        console.error("Error fetching data:", error.message);
        return null;
      }
    }
  }


  const handlePageReload = () => {
    let randomNumber = localStorage.getItem("randomNumber");
    if (randomNumber) {
      randomNumber = parseInt(randomNumber, 10) + 1;
    } else {
      randomNumber = 1;
    }
    setRandomState(randomNumber)
    localStorage.setItem("randomNumber", randomNumber);

    // Append randomNumber to the URL
    const url = new URL(window.location.href);
    url.searchParams.set("randomNumber", randomNumber);
    window.location.href = url.toString();
  };

  useEffect(() => {
    if (localStorage) {
      let randomNumber = localStorage.getItem("randomNumber");
      setRandomState(randomNumber)
    }
  }, [localStorage])


  useEffect(() => {
    if (comverse_customer_token) {
      fetchDashboardDetails();
    }
  }, [comverse_customer_token]);

  return (
    <Col className="DashboardModule padding20">
      <Space className="width100 flexBetween padding10">
        <Text className="font14">My Dashboard </Text>
        {/* test{randomState}
        <ReloadOutlined
          onClick={handlePageReload}
          style={{
            backgroundColor: "var(--background-color)",
            padding: "7px",
            borderRadius: "5px",
            fontSize: "16px",
            cursor: "pointer",
            color: "white",
            marginRight: "10px",
          }}
        /> */}
      </Space>

      <Row className="" justify="space-between">
        <Col flex="66.8%" className="ordersListing">
          <Col span={24} className="padding10">
            <Row justify="space-between" className="width100">
              <Col flex="0 0 48.5%" className="rewardCard flexCenter">
                <Space direction="vertical" className="width100">
                  <Space className="flexBetween width100">
                    <Space direction="vertical">
                      <Text className="font14">Reward Points</Text>
                      <Text className="font16Bold">
                        {DashboardDetails?.loyalty_points
                          ? DashboardDetails?.loyalty_points
                          : 0}
                        &nbsp;Points
                      </Text>
                    </Space>

                    <Image
                      width="35px"
                      height="auto"
                      preview={false}
                      alt="Reward Points"
                      src={RewardPoints}
                    />
                  </Space>

                  <Space>
                    <Text style={{ color: "#B7B7B7", fontSize: "10px" }}>
                      Balance
                    </Text>
                    <Text className="font10 poppinsSemiBold">
                      1 Point = 1 PKR
                    </Text>
                  </Space>
                </Space>
              </Col>

              <Col flex="0 0 48.5%" className="walletCard flexCenter">
                <Space direction="vertical" className="width100">
                  <Space className="flexBetween width100">
                    <Space direction="vertical">
                      <Text className="font14">My Wallet</Text>
                      <Text className="font16Bold">
                        {DashboardDetails?.wallet_points
                          ? DashboardDetails?.wallet_points
                          : 0}
                        &nbsp;Points
                      </Text>
                    </Space>

                    <Image
                      src={Coins}
                      width="35px"
                      height="auto"
                      preview={false}
                      alt="Wallet Points"
                    />
                  </Space>

                  <Space>
                    <Text style={{ color: "#B7B7B7", fontSize: "10px" }}>
                      Balance
                    </Text>
                  </Space>
                </Space>
              </Col>
            </Row>
          </Col>

          <Col span={24} className="ordersHistory marginTop20">
            <Col span={24}>
              {DashboardDetails?.orders?.length > 0 ? (
                <Col span={24}>
                  {DashboardDetails?.orders.map((order, index) => {
                    return (
                      <OrderCard
                        key={index}
                        count={index + 1}
                        OrderDetail={order}
                      />
                    );
                  })}
                </Col>
              ) : (
                <Col span={24} className="no-order-found-text-div">
                  <Typography className="no-order-found-text">
                    No Orders Found
                  </Typography>
                </Col>
              )}
            </Col>
          </Col>
        </Col>

        <Col flex="28%" className="customerHistory">
          <Col className="infoCard">
            <Col>
              <Space className="flexBetween">
                <Text className="font14Bold">Personal Info</Text>
                <DynamicButton
                  //changeActiveMenuReducer
                  name="Edit"
                  function={() => {
                    dispatch(changeActiveMenuReducer("edit"));
                  }}
                  style={{ border: "none", color: "#5A7184", fontSize: "11px" }}
                />
              </Space>
            </Col>

            <Col
              style={{
                padding: "5px 0px",
                borderTop: "1px solid #E2E5F1",
                borderBottom: "1px solid #E2E5F1",
              }}
            >
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Name:&nbsp;
                {DashboardDetails?.profile?.full_name
                  ? DashboardDetails?.profile?.full_name
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Email:&nbsp;
                {DashboardDetails?.profile?.email
                  ? DashboardDetails?.profile?.email
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Mobile Number:&nbsp;
                {DashboardDetails?.profile?.phone
                  ? DashboardDetails?.profile?.phone
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Gender:&nbsp;
                {DashboardDetails?.profile?.gender
                  ? DashboardDetails?.profile?.gender
                  : "N/A"}
              </Text>
              <br />
            </Col>
          </Col>
        </Col>
      </Row>
    </Col>
  );
}
